import getLicenses from './getLicenses';

const watchLicenses = [getLicenses];

export default watchLicenses;
